import { postMiReport } from '../api/mi-api';
import { ProductClient } from '../types/types';
import { setCustomLink, isNativeView, messageReceived } from '@vm/omega-shared-component-webapp';

const hasQueryParams = (url: string): boolean => {
  return url.includes('?');
};

export const tryHandleThirdPartyCTA = async (client: ProductClient, cta: string, productId: string) => {
  if (!cta) {
    throw 'Failed to handle tp cta';
  }
  if (client.isIntegrated) {
    // Note: tp sso not implemented yet
    throw 'Failed to handle tp cta';
  } else {
    return postMiReport(productId, client.id).then(({ status, data }) => {
      let tpCtaUrl = null;
      if (status === 201 || status === 200) {
        if (data?.transactionId) {
          tpCtaUrl = encodeURI(cta + (hasQueryParams(cta) ? '&' : '?') + 'txid=' + data.transactionId);
        }
      }
      if (tpCtaUrl) {
        setCustomLink({ linkDescription: `cta-tp-apply-${productId}-pass` });
        window.open(tpCtaUrl);
      } else {
        setCustomLink({ linkDescription: `cta-tp-apply-${productId}-fail` });
        throw 'Failed to handle tp cta';
      }
    });
  }
};

// We know OK has been selected by the user
export const tryHandleThirdPartyCTANative = async (cta: string, productId: string, clientId: string) => {
  if (!cta) {
    throw 'Failed to handle native tp cta';
  }

  if (!isNativeView()) {
    throw 'tryHandleThirdPartyCTANative called for non-native view';
  }

  return postMiReport(productId, clientId).then(({ status, data }) => {
    let tpCtaUrl = null;
    if (status === 201 || status === 200) {
      if (data?.transactionId) {
        tpCtaUrl = encodeURI(cta + (hasQueryParams(cta) ? '&' : '?') + 'txid=' + data.transactionId);
      }
    }
    if (tpCtaUrl) {
      setCustomLink({ linkDescription: `cta-tp-apply-${productId}-native-pass` });
      messageReceived(tpCtaUrl);
    } else {
      setCustomLink({ linkDescription: `cta-tp-apply-${productId}-native-fail` });
      throw 'Failed to handle native tp cta';
    }
  });
};
